import { BaseWheelDrawer } from './BaseWheelDrawer';
import { gameMobileConfig } from '../../../core/configs';
import { GAME_SCENE } from '../../../core/constats';
import { wheelDarkResource, wheelLightResource, wheelResourceNames } from '../../../core/gameConstants';
import { animationDrawer } from '../../../core/AnimationDrawer';
import { GAME_SCENE_STATE } from '../../../stateManagment/gameState';
import { spinResponseHelper } from '../../../services/helperService/SpinResponseHelper';
import { bonusSpinResponseHelper } from '../../../services/helperService/BonusSpinResponseHelper';
import { crystalPerTypeHelper } from '../../../services/helperService/CrystalPerTypeHelper';

export class WheelMobileDrawer extends BaseWheelDrawer {
  constructor() {
    super();
    this.container = null;
    this.loader = this.createLoader();
    this.config = {
      position: { x: 0, y: 0 },
      imagePosition: { x: 0, y: 0 },
    };
  }

  setWheel({ dark = false, crystals } = {}) {
    const { circle } = this.getWheel({
      x: 0,
      y: 0,
      crystalCount: 64,
      radius: 252,
      imageSize: { w: 40, h: 40 },
      imgPosition: { x: -7.5 },
      crystals,
      scale: Number(!dark)
    });
    this.winContainer.children = [];
    const goldenElementTexture = this.getGoldenElementTexture();
    const goldenRingTexture = this.getGoldenRingTexture();
    const wheelLight = this.getWheelLight();
    const wheelTexture = this.getWheelTexture(undefined, dark);

    this.setPosition(wheelTexture, this.config.imagePosition);
    this.setPosition(goldenElementTexture, this.config.imagePosition);
    this.setPosition(goldenRingTexture, this.config.imagePosition);

    this.container.addChild(
      wheelTexture,
      this.winContainer,
      wheelLight,
      goldenRingTexture,
      this.wheelContainer,
      goldenElementTexture,
    );
    if (dark) {
      this.winContainer.addChild(this.getPressToContinue(1.1));
    } else {
      this.winContainer.addChild(this.getGoodLuck());
    }
    this.circle = circle;
  }

  resetWheelCrystals() {
    this.container.children = [];
    this.setWheel({ dark: GAME_SCENE_STATE.getValue() === GAME_SCENE.BONUS, crystals: crystalPerTypeHelper.crystals });
  }

  rotate(resolve) {
    const helper = GAME_SCENE_STATE.getValue() === GAME_SCENE.MAIN ? spinResponseHelper : bonusSpinResponseHelper;
    super.rotateCircle(this.circle, resolve, helper);
  }

  setupContainer() {
    this.setPosition(this.container, gameMobileConfig.wheelPosition);
  }

  screenTransaction() {
    this.winContainer.children = [];
    const texture = this.createSpine(this.resources[wheelResourceNames.wheelScreenTransaction]);
    texture.state.setAnimation(0, 'animation', false);
    this.container.addChild(texture);
    animationDrawer.shake(this.container, .1, gameMobileConfig.wheelPosition);
  }

  onLoad() {
    return this.loadResource([
      ...wheelDarkResource,
      ...wheelLightResource,
    ]);
  }

  async executeMainScene() {
    await this.loadResource([...wheelLightResource]);
    this.setupContainer();
    this.setWheel();
  }

  async executeBonusScene() {
    await this.loadResource([...wheelDarkResource]);
    this.setupContainer();
    this.setWheel({ dark: true });
  }
}
